// extracted by mini-css-extract-plugin
export default {"main":"ReferredLandgPage_main__Jv47q","homepage":"ReferredLandgPage_homepage__rg4F6","header":"ReferredLandgPage_header__A1zEB","btn":"ReferredLandgPage_btn__OomiC"};